import React from 'react'
import PropTypes from 'prop-types'

const Share = ({ color = '#999999' }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Icons-/-Light-Grey-/-Share"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <g id="Group" transform="translate(6.000000, 5.000000)" stroke={color} strokeWidth="2">
        <path
          d="M2,4 L10,4"
          id="Path-3"
          transform="translate(6.000000, 4.000000) rotate(-270.000000) translate(-6.000000, -4.000000) "
        />
        <polyline
          id="Path"
          strokeLinejoin="round"
          transform="translate(6.000000, 2.000000) scale(1, -1) translate(-6.000000, -2.000000) "
          points="10 0 6 4 2 0"
        />
        <path
          d="M12,9 L12,11 C12,12.1045695 11.1045695,13 10,13 L2,13 C0.8954305,13 1.3527075e-16,12.1045695 0,11 L0,9"
          id="Path"
        />
      </g>
    </g>
  </svg>
)

Share.propTypes = {
  color: PropTypes.string,
}

export default Share
